import { Dispatch } from 'redux';
import { Position } from '@synergy/models';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';

export const RECEIVE_USER_POSITIONS = 'RECEIVE_USER_POSITIONS';

const receivePositions = (positions: Position[]) => {
    return { type: RECEIVE_USER_POSITIONS, positions };
};

export const fetchPositions = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.userManagement.getPositions();

        if (response.success) {
            dispatch(receivePositions(response.result));
        }
    };
};
